import FormBuilderTable from "../../../../../pages/app/admin/library/form-builder/FormBuilderTable";
import ElevatedPaper, { DEFAULT_STYLE } from "../../../../ElevatedPaper";

const ProviderFormBuilderTable = () => {
  return (
    <ElevatedPaper sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.5rem)" }}>
      <FormBuilderTable />
    </ElevatedPaper>
  );
};

export default ProviderFormBuilderTable;
